export enum InboundTaskItemAssignType {
  ASSIGN = 'assign',
  UNASSIGN = 'unassign',
}
